import { useEffect } from "react";
const reCaptchaHiddenBadgeStyles = `.grecaptcha-badge { visibility: hidden; }`;
const useHideRecaptchaBadge = () => {
  useEffect(() => {
    const styles = document.createElement("style");
    styles.textContent = reCaptchaHiddenBadgeStyles;
    document.head.appendChild(styles);
    return () => {
      document.head.removeChild(styles);
    };
  }, []);
};
var useHideRecaptchaBadge_default = useHideRecaptchaBadge;
export {
  useHideRecaptchaBadge_default as default,
  reCaptchaHiddenBadgeStyles
};
